export { default } from './YourTerms';
